import { IError } from "../types/interface/demanderRDV";

export const showErrorValuesDefault = {
    nomPrenom: false,
    telephone: false,
    mail: false,
    agence: false,
    objet: false,
    message: false,
};

export const showErrorValuesSubmit = {
    nomPrenom: true,
    telephone: true,
    mail: true,
    agence: true,
    objet: true,
    message: true,
};

export const defaultValues: IError = {
    nomPrenom: '',
    telephone: '',
    mail: '',
    agence: '',
    objet: '',
    message: '',
};

export const titleLabels = {
    contractant: {
        nomPrenom: 'Nom et prénom(s)',
        telephone: 'Téléphone ',
        mail: 'Mail',
        agence: 'Agence ',
        objet: 'Objet du message',
        message: 'Votre message',
    },
};
  